export type OrganizationPermissionRelation = 'can_manage_users' | 'can_reset_2fa' | 'can_create_workspace' | 'can_delete_workspace'

export type Organization = {
    id: string
    name: string
    createdAt: string
    flags?: Record<string, string | boolean>
    relations: OrganizationPermissionRelation[]
    logoUrl?: string
}

export const ORGANIZATION_FLAGS = {
    RUN_V3_WORKFLOWS: 'runV3Workflows',
}

export type OrganizationRole = {
    id: string
    name: string
    organizationId: string
}

export const OWNER_ROLE_NAME = 'owner'
export const ADMIN_ROLE_NAME = 'admin'

export const USER_STATUSES = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    PENDING: 'PENDING',
    TERMINATED: 'TERMINATED',
    FORGOTTEN: 'FORGOTTEN',
}

export type UserStatus = keyof typeof USER_STATUSES

export type UserRef = {
    id: string
    firstName: string
    lastName: string
    email: string
    avatarUrl?: string
}

export type OrganizationMembershipOverview = UserRef & {
    title?: string
    createdDateTime: string
    role: OrganizationRole
    status: UserStatus
}

export type User = OrganizationMembershipOverview & {
    organization: Organization
}
